import Vue from "vue";
import './plugins/vuetify'
import 'vuetify/src/stylus/app.styl'
import App from "./App.vue";
import router from "./router/";
import store from "./store";
import "./registerServiceWorker";
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import VeeValidate from 'vee-validate';

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate);

export default function setupInterceptor() {
  axios.interceptors.request.use(
    function (config) {
      const token = store.getters.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    function (err) {
      return Promise.reject(err);
    });
}

setupInterceptor();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
